// Só máscara de exibição (11) 98765-4321. Validar e normalizar é do servidor (BrMobile).
export function maskPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  const local = digits.length === 13 && digits.startsWith('55') ? digits.slice(2) : digits;

  if (local.length > 11) return value;
  if (local.length > 7) return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
  if (local.length > 2) return `(${local.slice(0, 2)}) ${local.slice(2)}`;
  return local && `(${local}`;
}
